import { render, staticRenderFns } from "./OrdersInFulfill.vue?vue&type=template&id=6b42242e&scoped=true"
import script from "./OrdersInFulfill.vue?vue&type=script&lang=js"
export * from "./OrdersInFulfill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b42242e",
  null
  
)

export default component.exports